export default function() {

	$(document).on('click', '[data-js-toggler]', function(){
		const btn = $(this);
		const wrapper = btn.closest('.js-toggler');``
		let targetEl;
		if (wrapper.length) {
			targetEl = wrapper.find(`[data-js-toggler-target="${btn.attr('data-js-toggler')}"]`);
			if (targetEl.data('js-toggle-height') !== undefined) {
				targetEl.toggleClass('show');
			} else {
				targetEl.slideToggle();
			}
			btn.toggleClass('js-active');
		} else {
			targetEl = $(`[data-js-toggler-target="${btn.attr('data-js-toggler')}"]`);
			if (targetEl.data('js-toggle-height') !== undefined) {
				targetEl.toggleClass('show');
			} else {
				targetEl.slideToggle();
			}
			btn.toggleClass('js-active');
		}

	});
}
